import styled from 'styled-components'
import { Text } from '@amzn/storm-ui'

export const MicroDashFrame = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(to right, ${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) top repeat-x,
    linear-gradient(${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) right repeat-y,
    linear-gradient(to right, ${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) bottom repeat-x,
    linear-gradient(${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) left repeat-y;
  background-size: 10px 1px, 1px 10px;
`

export const EmptyCompareContainer = styled(MicroDashFrame)`
  padding-top: ${({ theme }) => theme.spacing.xxlarge};
  padding-bottom: ${({ theme }) => theme.spacing.xlarge};
`
export const MicroEmptyCtaText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 45px;
  padding-inline-start: ${({ theme }) => theme.spacing.medium};
  padding-inline-end: ${({ theme }) => theme.spacing.medium};
`

export const EmptyCtaText = styled(Text)`
  padding-inline-start: ${({ theme }) => theme.spacing.medium};
  padding-inline-end: ${({ theme }) => theme.spacing.medium};
  text-wrap: balance;
  text-align: center;
`
